export const EmailJS_Services_Id = 'service_998zhgd';
export const EmailJS_template_Id = 'template_n5490uo';
export const EmailJS_public_key_Id = 'unPifyyNKL5_mlvB1';
